import React from 'react';
import cn from 'classnames';

import './Switcher.scss';

type Props = {
  id: string;
  isOneSideLabel?: boolean;
  hideLabels?: boolean;
  checked: boolean;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function Switcher({ id, checked, hideLabels = false, isOneSideLabel = false, className = '', onChange }: Props) {
  return (
    <div
      className={cn(`${className} switcher d-flex align-items-center flex-shrink-0`, {
        'switcher--default': hideLabels,
      })}
    >
      {!hideLabels && !isOneSideLabel && !checked ? <div className="switcher-mark">Off</div> : null}
      <div className="switcher-content d-flex custom-control custom-switch p-0">
        <input type="checkbox" className="custom-control-input" id={id} checked={checked} onChange={onChange} />
        <label className="custom-control-label" htmlFor={id} />
      </div>
      {!hideLabels && isOneSideLabel && !checked ? <div className="switcher-mark">Off</div> : null}
      {!hideLabels && checked ? <div className="switcher-mark">On</div> : null}
    </div>
  );
}

export default Switcher;
